import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import StyledButton from "../ui/StyledButton";

// Styled components
const FeatureBoxWrapper = styled.div`
    margin: 80px 0;
    border: 1px solid var(--primary-color);
    padding: 40px;
    position: relative;
    background-color: rgba(0, 0, 0, 0.7);
    overflow: hidden;

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: linear-gradient(90deg, var(--primary-color), transparent);
    }
`;

// Static corner element
const CornerElement = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;

    &:before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        border-style: solid;
        border-width: 0 30px 30px 0;
        border-color: transparent var(--primary-color) transparent transparent;
        opacity: 1;
    }
`;

const FeatureTitle = styled.h3`
    font-size: 32px;
    margin-bottom: 20px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 2px;
    color: var(--primary-color);
    position: relative;
    display: inline-block;

    &:before {
        content: ">";
        margin-right: 10px;
        opacity: 0.7;
    }
`;

const FeatureDescription = styled.p`
    font-size: 18px;
    max-width: 800px;
    margin-bottom: 30px;
    position: relative;
`;


const SystemInfo = styled.div`
    position: absolute;
    bottom: 15px;
    right: 15px;
    font-size: 10px;
    color: var(--grid-color);
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const PixelCorner = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 30px;
    height: 30px;
    z-index: 1;

    &:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 5px;
        height: 5px;
        background-color: var(--primary-color);
        box-shadow:
                5px 0 0 0 var(--primary-color),
                0 5px 0 0 var(--primary-color),
                10px 0 0 0 var(--primary-color),
                0 10px 0 0 var(--primary-color),
                5px 5px 0 0 var(--primary-color),
                10px 5px 0 0 var(--primary-color),
                5px 10px 0 0 var(--primary-color),
                10px 10px 0 0 var(--primary-color);
        opacity: 0.7;
    }
`;

const FeatureBox = () => {
    return (
        <FeatureBoxWrapper>
            <CornerElement />
            <PixelCorner />

            <FeatureTitle>CONNECT</FeatureTitle>
            <FeatureDescription>
                Enjoyed exploring? If anything here resonated with you, whether you think we could build something together or just want to exchange a few words, feel free to reach out. I'd love to hear from you.
            </FeatureDescription>

            <StyledButton to="/contact">INITIATE CONTACT</StyledButton>

            <SystemInfo>[ SYSTEM.VERSION 5.4.62 // STATUS: ONLINE ]</SystemInfo>
        </FeatureBoxWrapper>
    );
};

export default FeatureBox;